// extracted by mini-css-extract-plugin
export default {"caption":"Khus7","prevMonthBtn":"untkc","text":"NoPWi","nextMonthBtn":"jaQyS"};